// extracted by mini-css-extract-plugin
export default {"loaderSection":"loader_loaderSection__wFiva","loaderSecitionh1":"loader_loaderSecitionh1__mwawa","lds_ring":"loader_lds_ring__ofqc0"};